var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"step mt-2"},[_c('span',{staticClass:"step-number"},[_vm._v(_vm._s(_vm.number))]),_c('v-card-title',{staticClass:"step-title pt-6"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-card-text',[_c('div',{staticClass:"step-content"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }